// removed by extract-text-webpack-plugin
module.exports = {"DriverStatus":"DriverStatus__DriverStatus__1USXj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DriverStatus/DriverStatus.css
// module id = 214
// module chunks = 1